import React, { Component } from 'react'
import { connect } from 'react-redux';
let RichEditor = null;

class Editor extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RichEditor !== null };
  	}

  	componentWillMount() {
  		const {isEditor} = this.props
  		
  		if(!isEditor) return
  		this.load()
  	}
  	
	componentWillReceiveProps({isEditor}) {
		if(isEditor && !RichEditor) this.load()
	}

  	load() {
    	require.ensure('../admin', () => {
      		RichEditor = require('../admin').RichEditor;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

	getText() {
		if(this.editor) return this.editor.getWrappedInstance().getText()
		return null
	}

  	render() {
  		return this.state.isReady ? <RichEditor ref={(c) => {this.editor=c}} {...this.props} /> : null
  	}
}
export default connect(state => ({isEditor: state.auth.isEditor}), null, null, {withRef: true})(Editor);


// WEBPACK FOOTER //
// ./src/fm/admin/editor/Editor.js